import React from "react";
import Skeleton from '@mui/material/Skeleton';
import { Box, Grid } from "@mui/material";

const skeletonProps = {
	animation: "wave",
	width: "100%",
	variant: "rect"
};

export default function Loading() {
	return (
		<>
			<Box my="16px" width="100%">
				<Skeleton {...skeletonProps} height="4vh" />
			</Box>
			<Grid container spacing={2}>
				<Grid item xs={12} sm={9} md={8} lg={8}>
					<Skeleton {...skeletonProps} height="50vh" />
				</Grid>
				<Grid item xs={12} sm={3} md={4} lg={4}>
					<Skeleton {...skeletonProps} height="50vh" />
				</Grid>
			</Grid>
		</>
	);
}
